import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    labelDelete: string;
    labelDuplicate: string;
    labelRename: string;
    labelShare: string;
    labelChangeVisibility: string;
    privateCollectionText: {
        /** Label for private collection visibility option */
        label: string;
        /** Description for private collection visibility option */
        details: string;
    };
    publicCollectionText: {
        /** Label for team collection visibility option */
        label: string;
        /** Description for team collection visibility option */
        details: string;
    };
    shareListViewDisclaimerTooltip: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Menu item label for deleting a collection */
            labelDelete: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenuOptionsForCollection.labelDelete?c=7nzkz7owpk0x", defaultMessage: "Delete" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label for duplicating a collection */
            labelDuplicate: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenuOptionsForCollection.labelDuplicate?c=gwcnintdwpnx", defaultMessage: "Duplicate" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label for renaming a collection */
            labelRename: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenuOptionsForCollection.labelRename?c=2xvuf86b5nq1g", defaultMessage: "Rename" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label for sharing a collection */
            labelShare: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenuOptionsForCollection.labelShare?c=2q6axuzhi9fhl", defaultMessage: "Share" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label for changing collection visibility */
            labelChangeVisibility: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenuOptionsForCollection.labelChangeVisibility?c=2gtffarjs2ysy", defaultMessage: "Change Visibility" }));
                },
                enumerable: true,
                configurable: true
            },
            privateCollectionText: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Label for private collection visibility option */
                        label: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenuOptionsForCollection.privateCollectionText.label?c=17gm55cf8c3x1", defaultMessage: "Private Collection" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description for private collection visibility option */
                        details: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenuOptionsForCollection.privateCollectionText.details?c=30cjts7oxvyjx", defaultMessage: "Only you can see and edit this Collection" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            publicCollectionText: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Label for team collection visibility option */
                        label: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenuOptionsForCollection.publicCollectionText.label?c=3jtil7y8gzqs", defaultMessage: "Team Collection" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description for team collection visibility option */
                        details: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenuOptionsForCollection.publicCollectionText.details?c=ihd0e7bnp1ql", defaultMessage: "All Project members can see and edit this Collection" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Tooltip explaining that shares use grid layout */
            shareListViewDisclaimerTooltip: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContextMenuOptionsForCollection.shareListViewDisclaimerTooltip?c=2gjw229fhb678", defaultMessage: "List view is not currently available for Shares. This collection will be shared with a Grid layout." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
